import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchhistorique'
})
export class SearchhistoriquePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value) return null;
    if(!args) return value;

    args = args.toLowerCase();

    return value.filter((item: any) => {
      return JSON.stringify(item.id_transaction).toLowerCase().includes(args) 
      || JSON.stringify(item.service).toLowerCase().includes(args)
      || JSON.stringify(item.montant).toLowerCase().includes(args)
      || JSON.stringify(item.date_paiement).toLowerCase().includes(args)
      || JSON.stringify(item.etat).toLowerCase().includes(args);
    })
  }

}
